import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import styles from "../../masters/master.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import { Link } from "react-router-dom";
let columns,
  columnsExpiry = [
    {
      name: "S.No",
      selector: "srNo",
      sortable: false,
      grow: 1,
    },
    {
      name: "Asset Name",
      selector: "assetName",
      sortable: false,
      grow: 3,
    },
    {
      name: "Brand",
      selector: "brandName",
      sortable: false,
      grow: 3,
    },
    {
      name: "Lease Number",
      selector: "leaseCode",
      grow: 2,
      sortable: false,
    },
    {
      name: "Unit Number",
      selector: "unit_no",
      grow: 2,
      sortable: false,
    },
    {
      name: "Gross Leasable Area (sq.ft)",
      selector: "gross_leasable_area",
      grow: 2,
      sortable: false,
    },
    {
      name: "Lease Term",
      selector: "leaseTerm",
      grow: 2,
      sortable: false,
    },
    {
      name: "Lease Commencement Date",
      selector: "lcd",
      grow: 2,
      sortable: false,
    },
    {
      name: "Lease Expiry Date",
      selector: "led",
      grow: 2,
      sortable: false,
    },
    {
      name: "Renewal Option",
      selector: "renewal_option",
      grow: 2,
      sortable: false,
    },
    {
      name: "Renewal Notice Due On",
      selector: "renewal_notice_due",
      grow: 2,
      sortable: false,
    },
  ];

let columnsLockIn = [
  {
    name: "S.No",
    selector: "srNo",
    sortable: false,
    grow: 1,
  },
  {
    name: "Asset Name",
    selector: "assetName",
    sortable: false,
    grow: 3,
  },
  {
    name: "Brand",
    selector: "brandName",
    sortable: false,
    grow: 3,
  },
  {
    name: "Lease Number",
    selector: "leaseCode",
    grow: 2,
    sortable: false,
  },
  {
    name: "Unit Number",
    selector: "unit_no",
    grow: 2,
    sortable: false,
  },
  {
    name: "Gross Leasable Area (sq.ft)",
    selector: "gross_leasable_area",
    grow: 2,
    sortable: false,
  },
  {
    name: "Lease Term",
    selector: "leaseTerm",
    grow: 2,
    sortable: false,
  },
  {
    name: "Lock-In Start Date",
    selector: "llsd",
    grow: 2,
    sortable: false,
  },
  {
    name: "Lock-In End Date",
    selector: "lled",
    grow: 2,
    sortable: false,
  },
  {
    name: "Termination Notice Period",
    selector: "lease_expiry_np",
    grow: 2,
    sortable: false,
  },
];

let columnsRent = [
  {
    name: "S.No",
    selector: "srNo",
    sortable: false,
    grow: 1,
  },
  {
    name: "Asset Name",
    selector: "assetName",
    sortable: false,
    grow: 3,
  },
  {
    name: "Brand",
    selector: "brandName",
    sortable: false,
    grow: 3,
  },
  {
    name: "Lease Number",
    selector: "leaseCode",
    grow: 2,
    sortable: false,
  },
  {
    name: "Unit Number",
    selector: "unit_no",
    grow: 2,
    sortable: false,
  },
  {
    name: "Gross Leasable Area (sq.ft)",
    selector: "gross_leasable_area",
    grow: 2,
    sortable: false,
  },
  {
    name: "Lease Term",
    selector: "leaseTerm",
    grow: 2,
    sortable: false,
  },
  {
    name: "Current Rent Logic",
    selector: "old_logic",
    grow: 2,
    sortable: false,
  },
  {
    name: "Current Rent",
    selector: "old_rent",
    grow: 2,
    sortable: false,
  },
  {
    name: "New Rent Logic",
    selector: "new_logic",
    grow: 2,
    sortable: false,
  },
  {
    name: "New Rent",
    selector: "new_rent",
    grow: 2,
    sortable: false,
  },
];

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>
  </>
);

const AlertsTable = (params) => {
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  var frequency = params.frequency;

  var additionalParams = "expiry_report=true&"+params.additionParams;
  if (params.leaseData == "LOCKIN EXPIRY") {
    additionalParams = "expiry_lockin_report=true&"+params.additionParams;
    columns = columnsLockIn;
  }else if (params.leaseData == "LEASE EXPIRY") {
    additionalParams = "expiry_report=true&"+params.additionParams;
    columns = columnsExpiry;
  } else {
    additionalParams = "rent_expiry=true&"+params.additionParams;
    columns = columnsRent;
  }

  additionalParams += "&frequency=" + frequency;

  React.useEffect(() => {
    fetchLeaseData(1);
  }, [filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchLeaseData = async (page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/user-alert/get-all-leases?page=${page}&per_page=${perPage}&${additionalParams}`
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchLeaseData(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/user-alert/get-all-leases?page=${page}&per_page=${newPerPage}&${additionalParams}`
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchLeaseData(1);
  }, []);

  return (
    <div className="alertsTableContainer">
      <DataTable
        columns={columns}
        data={data}
        customStyles={datatableOptions.datatableOptions.customStyle}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        onChangePage={handlePageChange}
        paginationComponentOptions={
          datatableOptions.datatableOptions.paginationOptions
        }
      />
    </div>
  );
};
export default AlertsTable;
